import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type PriorityPreference = "system" | "distance" | "amount";
export type RoutePreference = "short" | "long";
export type CargoPreference = "bulk" | "general";
export type ContextTemplate = "none" | "max" | "medium";
export type ResponseStyle = "concise" | "detailed" | "professional";

export interface MatchSettings {
  // 偏好设置
  priorityPreference: PriorityPreference;
  routePreference: RoutePreference;
  cargoPreference: CargoPreference;

  // 上下文设置
  contextTemplate: ContextTemplate;
  customContext: string;

  // 模型设置
  responseStyle: ResponseStyle;
}

const defaultMatchSettings: MatchSettings = {
  priorityPreference: "system",
  routePreference: "short",
  cargoPreference: "general",
  contextTemplate: "medium",
  customContext: "",
  responseStyle: "concise",
};

interface MatchSettingsState extends MatchSettings {
  setPriorityPreference: (preference: PriorityPreference) => void;
  setRoutePreference: (preference: RoutePreference) => void;
  setCargoPreference: (preference: CargoPreference) => void;
  setContextTemplate: (template: ContextTemplate) => void;
  setCustomContext: (context: string) => void;
  setResponseStyle: (style: ResponseStyle) => void;
  resetSettings: () => void;
}

export const useMatchSettingsStore = create<MatchSettingsState>()(
  persist(
    (set) => ({
      ...defaultMatchSettings,

      setPriorityPreference: (preference) =>
        set({ priorityPreference: preference }),
      setRoutePreference: (preference) => set({ routePreference: preference }),
      setCargoPreference: (preference) => set({ cargoPreference: preference }),
      setContextTemplate: (template) => set({ contextTemplate: template }),
      setCustomContext: (context) => set({ customContext: context }),
      setResponseStyle: (style) => set({ responseStyle: style }),

      resetSettings: () => set(defaultMatchSettings),
    }),
    {
      name: "match-settings-storage",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
